module.exports = __webpack_public_path__ + "static/media/iosLogo.507c0119.svg";